import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

const StyledTypography = withStyles({
  root: {
    color: '#757575',
    marginBottom: 7,
    fontSize: 14,
  },
})(Typography);

function InputLabel({ children }) {
  return <StyledTypography>{children}</StyledTypography>;
}

InputLabel.propTypes = {
  children: PropTypes.string.isRequired,
};

export default InputLabel;
